import slideManifestJson from '@digital-twins/slide-schemas/generated/slide-manifest.json'

export type ManifestLadderRung = { upTo: number; maxLines: number }

export type ManifestTextLimit = {
  maxChars: number
  minLines?: number
  maxLines?: number
  maxLinesByItemCount?: Array<ManifestLadderRung>
}

export interface ChartLimits {
  rankingSegmentedItems: number
  rankingMaxSegments: number
  doughnutMaxSegments: number
  pieMaxSegments: number
  quadrantMaxIcons: number
  quadrantMaxScatterPoints: number
  heatmapMaxRows: number
  heatmapMaxCols: number
  matrixMaxRows: number
  matrixMaxCols: number
  matrixMaxSegments: number
  horizontalBarMaxItems: number
  verticalBarMaxItems: number
  radarMaxItems: number
  numericMaxSegments: number
  groupedBarMaxLabels: number
  groupedBarMaxSeries: number
}

export interface InteractionLimits {
  minQuotesForDrawer: number
  minQuotesForEvidence: number
  maxTooltipQuotes: number
  maxFeedbackItems: number
  quadrantFeedbackItems: number
  maxDrawerMetrics: number
  tooltipOpenDelay: number
  tooltipCloseDelay: number
}

interface SlideManifestSchemaEntry {
  limits?: {
    items?: Record<string, number>
    text?: Record<string, ManifestTextLimit>
  }
}

interface SlideManifest {
  schemas?: Record<string, SlideManifestSchemaEntry>
  limits?: {
    textLimits?: Record<string, ManifestTextLimit>
    chartLimits?: ChartLimits
    interactionLimits?: InteractionLimits
  }
}

const slideManifest = slideManifestJson as SlideManifest
const manifestLimits = slideManifest.limits

if (!manifestLimits?.textLimits || !manifestLimits.chartLimits || !manifestLimits.interactionLimits) {
  throw new Error('Generated slide manifest is missing required limits metadata')
}

export const GLOBAL_TEXT_LIMITS: Record<string, ManifestTextLimit> = manifestLimits.textLimits
export const CHART_LIMITS: ChartLimits = manifestLimits.chartLimits
export const INTERACTION_LIMITS: InteractionLimits = manifestLimits.interactionLimits

export function hasManifestSchema(slideType: string): boolean {
  return !!slideManifest.schemas?.[slideType]
}

export function getManifestItemLimits(slideType: string): Record<string, number> {
  return slideManifest.schemas?.[slideType]?.limits?.items ?? {}
}

export function getManifestTextLimits(slideType: string): Record<string, ManifestTextLimit> {
  return slideManifest.schemas?.[slideType]?.limits?.text ?? {}
}
